export default {"src":"/_next/static/media/section1-img.fd156727.svg","height":594,"width":719,"blurWidth":0,"blurHeight":0};